import React, { useState } from "react";
import * as yup from "yup";
import Swal from "sweetalert2";
import store from "../../../../../store/store";
import AppForm from "../../../../../partials/content/Forms/AppForm";
import PosContent from "./posContent";
import { useEffect } from "react";
import { getUser } from "../../../../../services/usersService";
import { savePosSales } from "../../../../../services/sales/posService";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import PosReceipt from "../posReceipt";
import { DialogActions } from "@material-ui/core";
import { DateTime } from "luxon";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import { getCountries } from "../../../../../services/setup/customer/customerSetupService";
const posFormSchema = yup.object().shape({
  ID: yup.number(),
  payAmount: yup.number().when("payMethod", {
    is: (value) => value === 1,
    then: yup.number().min(1, "Payment Amount is required"),
  }),
  change: yup.number().when("payMethod", {
    is: (value) => value === 1,
    then: yup.number().min(0, "Change cannot be less than zero"),
  }),
  total: yup.number().min(1, "Total Sales cannot be zero or empty"),
  customerName: yup.string().when("payMethod", {
    is: (value) => value === 4,
    then: yup.string().required("Customer is required"),
  }),
  salesPosItem: yup
    .array()
    .of(
      yup.object().shape({
        ID: yup.number(),
        itemName: yup.string().required("Item is required"),
        qty: yup
          .number()
          .transform((value) => (isNaN(value) ? 0 : value))
          .nullable()
          .required("Quantity is required")
          .moreThan(0, "Quantity cannot be zero or empty")
          .default(0),
        totalPrice: yup.number().min(1, "Total Price cannot be zero or empty"),
      })
    )
    .required("Sales Item cannot be empty"),
});
function PosForm({ history }) {
  const { companyProfile, reload } = useGlobalData();
  const [openPosReceipt, setOpenPosReceipt] = useState(false);
  const [posReceipt, setPosReceipt] = useState({});
  const [countries, setCountries] = useState([]);
  const [pos, setPos] = useState({
    ID: 0,
    outletID: 0,
    outletName: "",
    currencyID: companyProfile.currency.ID,
    currencyCode: companyProfile.currency.currencyCode,
    userID: 0,
    userName: "",
    firstName: "",
    salesID: 0,
    salesName: "",
    discountID: 0,
    discountName: "",
    customerID: 0,
    customerName: "",
    payMethod: 1,
    cashAccountID: 0,
    payAmount: 0,
    change: 0,
    cardNo: 0,
    cardName: "",
    deadlineDate: DateTime.now().endOf("day"),
    scanBy: 1,
    subTotal: 0,
    discountPercent: 0,
    discountAmount: 0,
    taxPercent: 0,
    taxAmount: 0,
    total: 0,
    recipient: "",
    address: "",
    city: "",
    province: "",
    postalCode: "",
    addressPhone: "",
    addressEmail: "",
    countryCode: companyProfile.countryCode,
    countryName: "",
    salesNote: "",
    outlet: {},
    discount: {
      discountID: 0,
      discountName: "",
      discountType: 1,
      discountAmountType: 1,
      discountPercnet: 0,
      discountValue: 0,
    },
    salesPosItem: [],
  });

  useEffect(() => {
    getUserData();
    getCountriesData();
  }, [reload]);

  async function getUserData() {
    const { auth } = store.getState();
    const userID = auth.user.userID;
    if (userID) {
      const response = await getUser(userID);
      const { data } = response.data;
      const { user } = data;
      const posTmp = { ...pos };
      posTmp.userID = user.ID;
      posTmp.userName = user.fullName;
      posTmp.firstName = user.firstName;
      setPos(posTmp);
    }
  }

  async function getCountriesData() {
    const response = await getCountries();
    const { data } = response.data;
    setCountries(data.countries);
  }

  return (
    <React.Fragment>
      <AppForm
        initialValues={pos}
        validationSchema={posFormSchema}
        onSubmit={async (values, { setStatus, setSubmitting }) => {
          const salesData = { ...values };
          salesData.subTotal = parseFloat(salesData.subTotal);
          salesData.discountPercent = parseFloat(salesData.discountPercent);
          salesData.discountAmount = parseFloat(salesData.discountAmount);
          salesData.taxPercent = parseFloat(salesData.taxPercent);
          salesData.taxAmount = parseFloat(salesData.taxAmount);
          salesData.total = parseFloat(salesData.total);

          for (const item of salesData.salesPosItem) {
            item.qty = parseFloat(item.qty);
            item.unitPrice = parseFloat(item.unitPrice);
            item.discountPercent = parseFloat(item.discountPercent);
            item.discountAmount = parseFloat(item.discountAmount);
            item.taxPercent = parseFloat(item.taxPercent);
            item.taxAmount = parseFloat(item.taxAmount);
            item.totalPrice = parseFloat(item.totalPrice);
          }
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title:
                "Are you sure want to save this Point of Sales transaction ?",
              text: "Please note that you are responsible for this action",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                savePosSales(salesData).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Saved",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });
                  setPos({
                    ID: 0,
                    outletID: 0,
                    outletName: "",
                    currencyID: 0,
                    currencyCode: "",
                    userID: 0,
                    userName: "",
                    firstName: "",
                    discountID: 0,
                    discountName: "",
                    customerID: 0,
                    customerName: "",
                    payMethod: 1,
                    cashAccountID: 0,
                    payAmount: 0,
                    change: 0,
                    cardNo: 0,
                    cardName: "",
                    deadlineDate: DateTime.now().endOf("day"),
                    scanBy: 1,
                    subTotal: 0,
                    discountPercent: 0,
                    discountAmount: 0,
                    taxPercent: 0,
                    taxAmount: 0,
                    total: 0,
                    recipient: "",
                    address: "",
                    city: "",
                    province: "",
                    postalCode: "",
                    addressPhone: "",
                    addressEmail: "",
                    salesNote: "",
                    outlet: {},
                    discount: {
                      discountID: 0,
                      discountName: "",
                      discountType: 1,
                      discountAmountType: 1,
                      discountPercnet: 0,
                      discountValue: 0,
                    },
                    salesPosItem: [],
                  });
                  //const { salesPos } = response.data;
                  //salesData.ID = salesPos.ID;
                  setPosReceipt(salesData);
                  setOpenPosReceipt(true);
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        }}
      >
        <PosContent history={history} countries={countries} />
      </AppForm>
      <DialogLayout
        open={openPosReceipt}
        title="POS Receipt"
        onCloseDialog={() => {
          setOpenPosReceipt(false);
        }}
        maxWIdth="sm"
      >
        <PosReceipt
          salesData={posReceipt}
          outletData={posReceipt.outlet}
          userName={posReceipt.firstName}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenPosReceipt(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default PosForm;
